<!-- 由 suu 创建于 2022-01-07 星期五 -->
<!-- 经营、食品资质 -->
<template>
  <div class="qualification">
    <img
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/upred-pc-zz"
      alt=""
    />
    <img
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/upred-pc-sp"
      alt=""
    />
  </div>
</template>

<script>
export default {
  name: 'qualification',

  components: {},

  props: {},

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {}
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.qualification {
  width: 100vw;
  img {
    width: 100%;
    box-sizing: border-box;
  }
}
</style>
